import { useRouter } from "next/router";
import {
  getLocale,
  getServerBaseUrl,
  isPriceRankDevVnSite,
} from "~/lib/utils/urlHelper";
import { Project, PROJECT_ID_FAQ_PRICE_SALE } from "~/models/project";
import { LocaleEnum } from "~/services/locale/locale";

interface Props {
  asPath?: string;
  baseUrl?: string;
  project?: Project;
}

export const pageCanonicalUrl = ({
  asPath,
  baseUrl,
  project,
}: Props): string => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const router = useRouter();
  const pathname = router?.pathname;
  const originBaseUrl = getOriginBaseUrl({
    currentLocale: router?.locale,
    project,
  });
  const urlLocale = originBaseUrl ? "" : getLocale({ project, router });
  switch (pathname) {
    default:
      // router.asPath doesn't work properly in ISR
      return `${baseUrl || originBaseUrl || getServerBaseUrl()}${urlLocale}${
        asPath ?? router?.asPath
      }`;
  }
};

// modify canonical url for multi languages project
function getOriginBaseUrl({
  currentLocale,
  project,
}: {
  currentLocale?: string;
  project?: Project;
}): string {
  // modify domain faq.price-sale.com to game-question.com
  if (project?.id === PROJECT_ID_FAQ_PRICE_SALE) {
    return `https://${project.domain}`;
  }

  if (!project?.supportLocales || project.supportLocales.length <= 1) {
    return "";
  }

  // modify domain price-rank.dev to team.morizyun.com
  const serverBaseUrl = getServerBaseUrl();
  if (isPriceRankDevVnSite(serverBaseUrl) && currentLocale !== LocaleEnum.vn) {
    return `https://${project?.domain}/${currentLocale}`;
  }

  return currentLocale === LocaleEnum.vn
    ? `https://vn-${project?.domain}`
    : `https://${project?.domain}`;
}
